// import { PageTop } from "@fileforge/react-print";
import {
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell
} from "@mui/material";
import { styled } from "@mui/material/styles";

export default function PageHeader(props) {

    const betrokkene = props.betrokkene;
    const today = new Date();
    const DataCell = styled(TableCell)(({ theme }) => ({
        fontWeight: "bolder"
    }));

    return (
        <div>
            <TableContainer>
                <Table style={{ borderStyle: "none", borderWidth: 0 }}>
                    <TableBody>
                        <TableRow style={{ borderStyle: "none", borderWidth: 0 }}>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Kenmerk</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.kenmerk}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Naam</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.naam}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Naam Onderneming</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.naamOnderneming}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Email</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.email}</DataCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Geboortedatum</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.geboorteDatum}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Ongevaldatum</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.ongevalDatum}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Saldibalans t/m period</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.saldibalans}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >Rechtvorm</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0 }} >{betrokkene.rechtvorm}</DataCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{"Angifte " + betrokkene.jaarMinus3}</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{betrokkene.aangifteJaarMinus3 ? "Yes" : "No"}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{"Angifte " + betrokkene.jaarMinus2}</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{betrokkene.aangifteJaarMinus2 ? "Yes" : "No"}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{"Angifte " + betrokkene.jaarMinus1}</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{betrokkene.aangifteJaarMinus1 ? "Yes" : "No"}</DataCell>
                            <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >Print Date/Time</TableCell>
                            <DataCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderBottomStyle: "double" }} >{today.toLocaleDateString() + " " + today.toLocaleTimeString()}</DataCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    )
}